



































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
    import VpnReservedListBase from "./VpnReservedListBase";

	@Component
    export default class VpnReservedList extends VpnReservedListBase {

		showAllertToDeleteClick(itemsSelected: any) {
            if (this.$store.state.askBeforeDelete) {
                super.showAlertBeforeActionClickBase(itemsSelected, this.$t('vpnReserved.messageQuestionMain').toString(), true);
            }
			else {
                this.itemsSelected = itemsSelected;
                this.callActionClick();
            }
		}

		selectRows(items: any) {
			super.selectRows(items);
		}

		created() {
			super.initializeRights('COR_Setting_Global', 'COR_Setting_Global', 'COR_Setting_Global', 'COR_Setting_Global');
			super.created();
			super.setDetailName('VpnReservedDetail');
		};

		// VaP - toto zde musi byt, jinak nefunguje napojeni na tabulku
		loadFilters(value: any) { super.loadFilters(value); }
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) { super.detailClick(elementId); }		
		deleteClick(elementId: any) { super.deleteClick(elementId); }

	}
